export const MIN_PAUSE_DAYS = 21;
export const MAX_PAUSE_DAYS = 184;
export function schoolToday(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const get = type => parts.find(part => part.type === type).value;
  return get('year') + '-' + get('month') + '-' + get('day');
}
function dateValue(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(value + 'T00:00:00Z');
  return Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value ? null : date;
}
export function addPauseDays(value, days) {
  const date = dateValue(value);
  if (!date) return '';
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}
export function newPauseError(start, end, today = schoolToday()) {
  const a = dateValue(start), b = dateValue(end);
  if (!a || !b || end < start) return 'Please select valid dates. The end cannot precede the start.';
  if (start <= today) return 'A new pause can start from tomorrow at the earliest.';
  const days = (b.getTime() - a.getTime()) / 86400000;
  if (days < MIN_PAUSE_DAYS || days > MAX_PAUSE_DAYS) return 'A pause must last 21 to 184 days, including extensions.';
  return null;
}
